import { baseClient, getServiceURL } from '@/utils'


const fetchCountries = ({ lang, catalogId, simple }) => {
	return baseClient.get(`${getServiceURL('masters')}/v1/countries`, {
		params: {
			lang,
			catalogId,
			context: simple ? 'simple' : null
		}
	})
}

const fetchLevel2Entities = ({ countryGeonameId, level2Typology, searchTerm, lang }) => {
	return baseClient.get(
		`${getServiceURL('masters')}/v1/countries/${countryGeonameId}/${level2Typology.urlPath
		}`,
		{
			params: {
				search: searchTerm,
				lang
			}
		}
	)
}

const fetchLevel3Entities = ({
	countryGeonameId,
	level2Typology,
	level2GeonameId,
	level3Typology,
	searchTerm,
	lang
}) => {
	return baseClient.get(
		`${getServiceURL('masters')}/v1/countries/${countryGeonameId}/${level2Typology.urlPath
		}/${level2GeonameId}/${level3Typology.urlPath}`,
		{
			params: {
				search: searchTerm,
				lang
			}
		}
	)
}

export default {
	fetchCountries,
	fetchLevel2Entities,
	fetchLevel3Entities
}
